export default __webpack_public_path__ + "static/media/445.ff7a50aa.png";